(() => {
  if (window.EnvoiseBundleConcept) {
    window.EnvoiseBundleConcept.mount();
    return;
  }
  const instances = new Map();
  const create = root => {
    const owner = root.dataset.sectionId;
    const hours = Number(root.dataset.cycleHours) || 48;
    const duration = Math.min(96, Math.max(4, hours)) * 3600000;
    const storageKey = `envoise-concept-207020556629-${hours}h`;
    let end = 0;
    try { end = Number(localStorage.getItem(storageKey)); } catch {}
    const now = Date.now();
    if (!Number.isFinite(end) || end <= 0 || end > now + duration) end = now + duration;
    const persist = () => { try { localStorage.setItem(storageKey, String(end)); } catch {} };
    if (end <= now) end += (Math.floor((now - end) / duration) + 1) * duration;
    persist();
    let countdown;
    if (root.dataset.heroTimer !== 'false') {
      const hero = document.querySelector('.u-imgtxtneww-content');
      if (hero && !hero.querySelector('.ev-concept-countdown')) {
        const fragment = root.querySelector('#ev-concept-countdown').content.cloneNode(true);
        countdown = fragment.firstElementChild;
        countdown.dataset.evConceptOwner = owner;
        hero.appendChild(fragment);
      }
    }
    const stock = new Map([['9991267746133', 7], ['9991265452373', 4], ['9991265419605', 6]]);
    const mountBadges = () => {
      if (root.dataset.stock === 'false') return;
      document.querySelectorAll('.bys-card[data-product-id]').forEach(card => {
        const quantity = stock.get(card.dataset.productId);
        const image = card.querySelector('.bys-card__img');
        if (!quantity || !image || image.querySelector('.ev-concept-stock')) return;
        const fragment = root.querySelector(`#ev-concept-stock-${quantity}`).content.cloneNode(true);
        fragment.firstElementChild.dataset.evConceptOwner = owner;
        image.appendChild(fragment);
      });
    };
    mountBadges();
    const pad = value => String(value).padStart(2, '0');
    const tick = () => {
      const current = Date.now();
      if (current >= end) {
        end += (Math.floor((current - end) / duration) + 1) * duration;
        persist();
      }
      const remaining = Math.max(0, Math.ceil((end - current) / 1000));
      const h = pad(Math.floor(remaining / 3600));
      const m = pad(Math.floor(remaining % 3600 / 60));
      const s = pad(remaining % 60);
      const announcement = root.querySelector('[data-ev-announcement-timer]');
      if (announcement) announcement.textContent = `${h}:${m}:${s}`;
      if (countdown) {
        countdown.querySelector('[data-ev-hours]').textContent = h;
        countdown.querySelector('[data-ev-minutes]').textContent = m;
        countdown.querySelector('[data-ev-seconds]').textContent = s;
      }
    };
    tick();
    const grid = document.querySelector('[data-grid]');
    let observer;
    if (grid && root.dataset.stock !== 'false') {
      observer = new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.classList.contains('ev-concept-stock')))) mountBadges();
      });
      observer.observe(grid, {childList: true, subtree: true});
    }
    const interval = setInterval(tick, 1000);
    return {
      root,
      destroy() {
        clearInterval(interval);
        observer?.disconnect();
        countdown?.remove();
        document.querySelectorAll('.ev-concept-stock[data-ev-concept-owner]').forEach(badge => {
          if (badge.dataset.evConceptOwner === owner) badge.remove();
        });
      }
    };
  };
  const mount = () => {
    const root = document.getElementById('ev-bundle-concept');
    if (!root) return;
    const key = root.dataset.sectionId;
    const previous = instances.get(key);
    if (previous?.root === root) return;
    previous?.destroy();
    instances.set(key, create(root));
  };
  window.EnvoiseBundleConcept = {mount};
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    const instance = instances.get(event.detail.sectionId);
    instance?.destroy();
    instances.delete(event.detail.sectionId);
  });
  window.addEventListener('pagehide', () => {
    instances.forEach(instance => instance.destroy());
    instances.clear();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) mount(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true});
  else mount();
})();

